//import {galleryData} from "../store/GalleryData"
var request = require('../utils/request.js');
var gallery = {
    one: (id) => {
        return new Promise((resolve, reject)=>{
            request({
                url:'/api/gallery/' + id
            }).then((res = {}) => {
                if (res && res.pagedata) {
                    if (typeof res.pagedata !== 'object') {
                        try {
                            res.pagedata = JSON.parse(res.pagedata);
                        } catch (e) {
                            res.pagedata = {};

                        }
                    }

                }
                if (res && res.watermarks) {
                    if (typeof res.watermarks !== 'object') {
                        try {
                            res.watermarks = JSON.parse(res.watermarks);
                        } catch (e) {
                            res.watermarks = [];
                        }
                    }

                }
                res.tags = res.tags instanceof Array ? res.tags : (res.tags || "").split(',');
                return res;
            }).then(resolve).catch(reject);
        });
    },
    children: (id) => {
        return new Promise((resolve, reject) => {
            request({
                url: '/api/gallery/children/' + id
            }).then(res => {
                resolve(res);
            }).catch(reject)
        });
    },
    eventShow: (data) =>{
        return new Promise((resolve, reject)=>{
            request({
                url:'/api/stat/show',
                data:data
            }).then(res=>{
                resolve(res);
            }).catch(reject);
        });
    }
};

module.exports = gallery;



// WEBPACK FOOTER //
// ./src/actions/gallery.js